import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

import { DataGridTable, FormPage } from "../../components-old/ComponentsIndex";
import { DisplaySpinnerContext } from "../../context/ContextIndex";
import { selectSessionConfig } from "../../store/store-selector";
import { AppUtility } from "../../utils/utility";
import { useFetchListData } from "../../hooks/useFetchListData";

const PricingConfigurationListForm = () => {
  /**************************************************
  //Form handlers & hooks
  **************************************************/
  const { t } = useTranslation();
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);

  /**************************************************
  //Form State variables
  **************************************************/
  const [pricingConfigurationRecordList, setPricingConfigurationRecordList] = useState([]);
  const [dataGridPageSize, setDataGridPageSize] = useState(10);
  const [gridPageSizeOptions] = useState([10, 20, 50]);
  const [totalPricingConfigurationRowCount, setTotalPricingConfigurationRowCount] = useState(0);

  const PricingConfigurationList = useFetchListData(
    settingsConfig.businessCode,
    settingsConfig.countryCode,
    "getPricingConfigurationList",
    "pricingconfiguration"
  );

  /**************************************************
  //Event definitions
  **************************************************/
  //Data grid Page Size Change event
  const handlePageSizeChange = (newPageSize) => {
    setDataGridPageSize(newPageSize);
  };

  /**************************************************
  //Form on load useEffect
  **************************************************/
  useEffect(() => {
    const setPricingConfigurationList = (recordlist) => {
      try {
        if (recordlist.length) recordlist.sort((a, b) => new Date(b.ModifiedDate).getTime() - new Date(a.ModifiedDate).getTime());
        let _recordList = recordlist.map((item) => {
          return {
            id: item.ConfigId,
            configId: item.ConfigId,
            description: item.Description,
            configKey: item.ConfigKey,
            configValue: item.ConfigValue,
            recordResponse: item,
          };
        });

        setPricingConfigurationRecordList(_recordList);
        setTotalPricingConfigurationRowCount(_recordList.length);
        spinnerCtx.setLoadingIndicator(false);
      } catch (err) {
        spinnerCtx.setLoadingIndicator(false);
        alert(err);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    if (PricingConfigurationList) {
      setPricingConfigurationList(PricingConfigurationList);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PricingConfigurationList]);

  /**************************************************
  //JSX delcaration
  **************************************************/
  const buttonConfigs = [
    {
      buttonText: <SystemUpdateAltIcon />,
      buttonType: "outlined",
      onClick: () => {
        AppUtility.handleDownload(pricingConfigurationRecordList, "PricingConfiguration.xlsx");
      },
      buttonColor: "#A62B23",
      textColor: "#A62B23",
    },
  ];

  const dataGridSchema = [
    {
      field: "description",
      headerName: t("pricingConfigurationList.description"),
      flex: 1,
    },
    {
      field: "configKey",
      headerName: t("pricingConfigurationList.configKey"),
      flex: 1,
    },
    {
      field: "configValue",
      headerName: t("pricingConfigurationList.configValue"),
      flex: 1,
    },
    {
      field: "recordResponse",
      hide: true,
    },
  ];

  return (
    <FormPage isList={true}>
      <DataGridTable
        rows={pricingConfigurationRecordList}
        columns={dataGridSchema}
        pageSize={dataGridPageSize}
        pageSizeOptions={gridPageSizeOptions}
        onPageSizeChange={handlePageSizeChange}
        totalRowCount={totalPricingConfigurationRowCount}
        toolbarHeader={t("pricingConfigurationList.header")}
        toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
        buttonConfigs={buttonConfigs}
      />
    </FormPage>
  );
};

export default PricingConfigurationListForm;
